export default {
  getHistoryFieldFromField(field) {
    if (typeof field !== 'string') {
      return null;
    }
    return field.startsWith('data') ? `$${field}`.replace(/\//g, '.') : field;
  }
};